import React, { useMemo } from "react";
import { MeasureDropdown } from "./Dropdown";

export const DistanceUnitsDropdown = ({
  selectedDistanceUnits,
  setSelectedDistanceUnits,
}) => {
  const distanceUnitOptions = useMemo(
    () => [
      { value: "miles", label: "Miles" },
      { value: "kilometers", label: "Kilometers" },
      { value: "feet", label: "Feet" },
      { value: "meters", label: "Meters" },
      { value: "yards", label: "Yards" },
    ],
    []
  );
  return (
    <div>
      <MeasureDropdown
        selection={selectedDistanceUnits}
        setSelection={setSelectedDistanceUnits}
        options={distanceUnitOptions}
      />
    </div>
  );
};
